// extracted by mini-css-extract-plugin
export default {"Escalation":"styles_Escalation__wFNBS","row":"styles_row__9pYD0","text":"styles_text__ciCCO","title":"styles_title__RwhTX","info":"styles_info__tQudK"};